{
  "titles": {
    "menu": "Accounts",
    "table": "Accounts",
    "create": "Account aanmaken",
    "update": "Account wijzigen"
  },
  "fields": {
    "labels": {
      "Key": "Account nummer",
      "gender": "Geslacht",
      "initials": "Initialen",
      "firstNames": "Voornamen",
      "lastName": "Achternaam",
      "name": "Volledige naam",
      "email": "E-mailadres",
      "phone": "Telefoonnummer",
      "role": "Rol",
      "dateOfBirth": "Geboortedatum",
      "placeOfBirth": "Geboorteplaats",
      "address": "Adres",
      "isSigningAuthority": "Account is tekenbevoegd",
      "isRepresentative": "Account is vertegenwoordiger",
      "isIdentityValidated": "Identiteit spaarder controle",
      "true-isIdentityValidated": "Identiteit spaarder is gecontroleerd",
      "true-isBusinessInformationValidated": "KVK uittreksel & statuten zijn gecontroleerd"
    },
    "hints": {

    },
    "validationErrors": {
      "dateOfBirth": {
        "maxDate": "{0} mag niet in de toekomst liggen"
      },
      "isSigningAuthority": {
        "equals": "De vertegenwoordiger moet tekenbevoegd zijn"
      }
    }
  },
  "headers": {
    "labels": {
      "isSigningAuthority": "Tekenbevoegd",
      "isIdentityValidated": "Identificatie"
    }
  },
  "messages": {
    "createSuccess": "Account aangemaakt",
    "updateSuccess": "Account is opgeslagen",
    "checkedAtBy": "Gecontroleerd op {date} door {name}",
    "tableItemIsRepresentative": "Vertegenwoordiger"
  },
  "actions": {
    "create": "Account aanmaken",
    "search": "Zoek een account",
    "createAndAnother": "Nog een aanmaken",
    "update": "Account wijzigen"
  }
}
